import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { JsonConvert } from "json2typescript";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";

import {
    CapaFeasibilityRequest,
    CapaFeasibilityResponse,
} from "@hermes/api-model-perso";
import { Settings } from "@hermes/app-core";
import { CapaPersoNames } from "@hermes/states/personalization-page";
import { HTTP_JSON_CONTENT_TYPE_HEADER } from "@hermes/utils-generic/constants";

import { CAPA_CONSTANTS } from "app/pages/personalization-page/services/personalizationCapaService/personalization-capa.constants";

@Injectable()
export class PersonalizationCapaService {
    constructor(private http: HttpClient, private settings: Settings) {}

    /**
     * Get the feasibility for a specific SKU
     */
    public capaFeasibility(
        capaFeasibilityRequest: CapaFeasibilityRequest,
    ): Observable<CapaFeasibilityResponse> {
        const url = `${this.settings.apiUrl}/capa/checkfeasibility`;
        const payload = new JsonConvert().serialize(capaFeasibilityRequest);
        const headers = new HttpHeaders({
            ...HTTP_JSON_CONTENT_TYPE_HEADER,
        });
        return this.http.post(url, payload, { headers }).pipe(
            map((data) =>
                new JsonConvert().deserializeObject(
                    data,
                    CapaFeasibilityResponse,
                ),
            ),
            catchError(
                this.errorHandler<CapaFeasibilityResponse>(
                    "CAPA : Get feasibility error",
                ),
            ),
        );
    }

    /**
     * Create capa request
     */
    public createCapaRequest(
        sku: string,
        locale: string,
        productType: CapaPersoNames,
        dku?: string,
    ): CapaFeasibilityRequest {
        return new CapaFeasibilityRequest({
            locale,
            sku: sku.replace(" ", "v"),
            timestamp: CAPA_CONSTANTS.timestamp,
            perso: productType,
            idMagento: CAPA_CONSTANTS.idMagento,
            dku,
        });
    }

    public errorHandler<T>(message: string) {
        return (e: { error: string }): Observable<T> => {
            throw new Error(`${message} : ${e.error}`);
        };
    }
}
